import cookie from 'js-cookie';
import localforage from 'localforage';
import {
  STORAGE_KEY_TOKEN,
  STORAGE_KEY_USERINFO,
  CookieConfig,
  AccountType,
  AUTH_ROUTES_CONFIG,
} from '@/consts';
import { user } from '@/apis';
import { generateAuthMenus } from '@/utils/helpers';
import routesConfig from '@/routes.config';
import {
  USER_SET_TOKEN,
  USER_CLEAR_USERINFO,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT_SUCCESS,
  USER_SET_USERINFO,
  USER_SET_FUNCTIONLIST,
} from '../action-types';


export default {
  namespaced: true,
  state: {
    token: cookie.get(STORAGE_KEY_TOKEN),
    functionList: [],
    userInfo: null,
    logining: false,
    isChangePassword: false,
    maxLoginTimes: 99,
    globalState: {}, // 记录主应用和子应用的通信内容
  },
  mutations: {
    [USER_LOGIN_REQUEST](state) {
      state.logining = true;
    },
    [USER_LOGIN_SUCCESS](state) {
      state.logining = false;
    },
    [USER_LOGIN_FAIL](state) {
      state.logining = false;
    },
    [USER_SET_TOKEN](state, token) {
      cookie.set(STORAGE_KEY_TOKEN, token, CookieConfig);
      state.token = token;
    },
    [USER_SET_USERINFO](state, payload) {
      state.userInfo = payload;
    },
    [USER_SET_FUNCTIONLIST](state, payload) {
      state.functionList = payload;
    },
    [USER_LOGOUT_SUCCESS](state) {
      Object.assign(state, {
        token: null,
        userInfo: null,
      });
    },
    updateChangePwd(state, payload) {
      state.isChangePassword = payload;
    },
    updateMaxLoginTimes(state, payload) {
      if (payload !== null) {
        state.maxLoginTimes = payload;
      }
    },
    updateGlobalState(state, payload) {
      state.globalState = { ...state.globalState, ...payload };
    },
  },
  actions: {
    // 清除本地用户信息
    async [USER_CLEAR_USERINFO]() {
      await localforage.clear();
      Object.keys(cookie.get()).forEach(key => cookie.remove(key));
    },
    // 注销
    async logout({
      dispatch,
      commit,
    }) {
      // 服务端登出
      await user.logout();
      await dispatch(USER_CLEAR_USERINFO);
      window.location = process.env.LOGIN_PATH;
      commit(USER_LOGOUT_SUCCESS);
      commit('updateMaxLoginTimes', 99);
    },
    async loginReq({
      commit,
      dispatch,
    }, payload) {
      commit(USER_LOGIN_REQUEST);

      try {
        const result = await user.login(payload);
        if (result && result.code === '600001') {
          commit('updateContractInfo', {
            toastMessage: result.msg,
          }, { root: true });
          return Promise.reject();
        }
        const { token, ...userInfo } = result[0];
        await dispatch(USER_CLEAR_USERINFO);
        
        // 设置token
        commit(USER_SET_TOKEN, token);

        // 设置用户信息
        commit(USER_SET_USERINFO, userInfo);
        commit(USER_LOGIN_SUCCESS);
        commit('updateMaxLoginTimes', 99);

        // 是否提示更新密码
        commit('updateChangePwd', userInfo.isChangePassword);

        const functionList = await user.getUserFunctions(payload);
        
        commit(USER_SET_FUNCTIONLIST, functionList);
        
        
        const authRoutesConfig = generateAuthMenus(functionList, routesConfig);
        await localforage.setItem(AUTH_ROUTES_CONFIG, authRoutesConfig);
      } catch (e) {
        commit(USER_LOGIN_FAIL, e);
        // 接口返回账密最大可以试错次数，前端展示
        if (String(e).indexOf('账号已经被锁定') > -1) {
          commit('updateMaxLoginTimes', 0);
          throw new Error('账号已经被锁定,请联系管理员解锁!');
        }
        const execRst = String(e).match(/还剩(\d+)次机会/);
        const times = execRst && execRst.length ? execRst[1] : null;
        commit('updateMaxLoginTimes', times);
        const str = e.message;
        throw new Error(str);
      }
    },
    async loginByQrCode({
      commit,
      dispatch,
    }, payload) {
      try {
        const userInfo = await user.loginByCode(payload);
        await dispatch(USER_CLEAR_USERINFO);
        // 如果是门店账号登陆不让登陆
        if (userInfo.accountProducts) {
          const storeListTarget = userInfo.accountProducts.find(i => i.productId === 1);
          if (storeListTarget && storeListTarget.storeids && storeListTarget.storeids.length > 0) {
            throw new Error('没有登陆权限！');
          }
        }

        if (userInfo.accountType === AccountType.SUPER_ADMIN) {
          throw new Error('账号/密码错误!');
        }

        // 设置token
        commit(USER_SET_TOKEN, userInfo.token);
        const customUserInfo = await user.getUserInfo();
        // 设置用户信息
        await localforage.setItem(STORAGE_KEY_USERINFO, { ...customUserInfo, ...userInfo });
      } catch (e) {
        throw e;
      }
    },
    async editPwd(context, payload) {
      await user.editPwd(payload);
    },
  },
};
